import type { TollFreeRegistrationLiteModel } from '@src/service/model'

import Repository from './base'

export const TOLL_FREE_REGISTRATION_LITE_TABLE_NAME = 'tollFreeRegistrationLite'

export default class TollFreeRegistrationLiteRepository extends Repository<TollFreeRegistrationLiteModel> {}
